// Story 8.6 (ADO-2015): the "Order sent" message a "Submit now" send ends on, over the choice
// screen (Figma 5955:30315 desktop, 5955:30427 mobile).
//
// Desktop and tablet show the centred dialog, the check before the title and "Done" at the
// right of the footer. Mobile shows the bottom sheet (`placement="bottom"`, the 12px
// `compact` gutter), the check before the message and "Done" across the footer. "Done", the close button, Escape and the scrim all
// dismiss it; the Shopper stays on the choice screen.

import { Button, Icon, Modal } from '../../design-system';
import styles from './OrderSentDialog.module.css';

export interface OrderSentDialogProps {
  /** The sent cart as the choice screen names it ("Ambient", or "VC Dublin · Tobacco" where
   *  the entry names its account, Story 8.4), or null when no send has ended (closed). */
  readonly cartName: string | null;
  readonly placement: 'center' | 'bottom';
  readonly onClose: () => void;
}

export function OrderSentDialog({ cartName, placement, onClose }: OrderSentDialogProps) {
  const sheet = placement === 'bottom';
  const message = `Your ${cartName ?? ''} order has been sent.`;
  return (
    <Modal
      open={cartName !== null}
      onClose={onClose}
      title="Order sent"
      placement={placement}
      sheetGutter="compact"
      icon={sheet ? undefined : <Icon name="checkCircle" size={24} className={styles.check} />}
      footer={
        <Button
          variant="primary"
          fullWidth={sheet}
          className={sheet ? undefined : styles.done}
          onClick={onClose}
        >
          Done
        </Button>
      }
    >
      {sheet ? (
        <p className={styles.messageRow}>
          <Icon name="checkCircle" size={20} className={styles.check} />
          <span>{message}</span>
        </p>
      ) : (
        <p className={styles.message}>{message}</p>
      )}
    </Modal>
  );
}
